import { useTranslation } from "react-i18next";
import { Button } from "antd";
import Modals from "components/modal";

export default function ContractDrawer({
  setStarting,
  loading,
  open,
  onClose,
  onResetRiskAssessment,
}) {
  const { t } = useTranslation();
  return (
    <Modals
      className="risk-modal"
      closable
      width={335}
      destroyOnClose
      open={open}
      footer={
        <div className="flex gap-3 p-4 border-t border-gray--6 ">
          <Button
            block
            loading={loading}
            className="primary-button-large justify-center "
            onClick={() => {
              setStarting(true);
              onResetRiskAssessment({ onClose, setStarting });
            }}
          >
            {t("pma-onboarding.risk-assessment")}
          </Button>
          <Button
            block
            disabled={loading}
            className="default-button-large justify-center "
            onClick={onClose}
          >
            {t("cancel")}
          </Button>
        </div>
      }
      title={
        <span className="body-14px-regular text-gray-0">
          {t("pma-onboarding.trying-risk-assessment")}
        </span>
      }
      onCancel={onClose}
    >
      <>
        <div className="flex justify-between items-center p-5 pb-8 body-14px-regular text-gray-0">
          {t("pma-onboarding.reset-all-questions")}
        </div>
      </>
    </Modals>
  );
}
